import { CHAT_UI_THEME_TOKENS, DEFAULT_CHAT_UI_THEME } from '../theme/themeTokens.js';
import { MESSAGE_ATTACHMENT_CONSTRAINTS_HINT } from './composerShared.jsx';
export const CHAT_COMPOSER_DEFAULTS = Object.freeze({
  disabled: false,
  sendDisabled: false,
  loading: false,
  submitting: false,
  placeholder: '请输入内容',
  sendLabel: '发送',
  stopLabel: '停止',
  hintText: 'Enter 发送，Shift + Enter 换行',
  attachLabel: '上传文件',
  fileList: [],
  modeOptions: [],
  composerActions: [],
  composerChooser: null,
  modeStatusByKey: {},
  shortcutAction: null,
  shortcutActions: [],
  inputRef: null,
  themeTokens: CHAT_UI_THEME_TOKENS[DEFAULT_CHAT_UI_THEME],
  embedded: false,
  attachmentConstraintsHint: MESSAGE_ATTACHMENT_CONSTRAINTS_HINT,
  activeTargetChip: null,
  onActiveTargetDismiss: null,
});

export function conditionalValue(condition, whenTrue, whenFalse) {
  return condition ? whenTrue : whenFalse;
}

export function normalizeTargetProps({ activeTargetChip = null, onActiveTargetDismiss = null, ...props }) {
  return { ...props, activeTargetChip, onActiveTargetDismiss };
}

export function composerBoxClassName(attachmentDragActive, isBusy) {
  return [
    'flare-composer-box',
    attachmentDragActive ? 'is-drag-over' : '',
    isBusy ? 'is-loading' : '',
  ].filter(Boolean).join(' ');
}
